import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["children"],
    _excluded2 = ["children"],
    _excluded3 = ["children"];
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

var PanelFormComponent = function PanelFormComponent(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("div", props, children);
};

PanelFormComponent.propTypes = {
  children: PropTypes.node
};

PanelFormComponent.Header = function (_ref2) {
  var children = _ref2.children,
      props = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/React.createElement("div", _extends({
    className: "heading"
  }, props), children);
};

PanelFormComponent.Header.propTypes = {
  children: PropTypes.node
};

PanelFormComponent.Block = function (_ref3) {
  var children = _ref3.children,
      props = _objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/React.createElement("div", _extends({
    className: "block"
  }, props), children);
};

PanelFormComponent.Block.propTypes = {
  children: PropTypes.node
};
var StyledPanelForm = styled(PanelFormComponent).withConfig({
  componentId: 'dmi-ui-panelform'
}).withConfig({
  displayName: "Panel__StyledPanelForm",
  componentId: "sc-635ep9-0"
})(["border-radius:0;& + &{margin-top:30px;}.heading{background:", ";border-radius:0;border-top:none;border-left:none;border-right:none;border-bottom:1px solid ", ";font-weight:700;font-size:16px;padding:16px 16px 16px 42px;}.block{padding:8px 30px 30px 42px;background:", ";border-bottom:none;border-left:none;border-right:none;& > .grid:first-child{margin-top:0;padding-top:10px;}}.languages{font-size:12px;margin-bottom:12px;& > div{display:inline-block;}a{color:black;display:inline-block;&:first-child::after{content:'|';margin:0 5px;display:inline-block;font-weight:bold;}&.active{font-weight:bold;}}}.ui.left.icon.input{display:flex;align-items:center;justify-content:flex-start;i{margin:0 10px 0 0 !important;}}"], function (props) {
  return props.$bodycolor;
}, function (props) {
  return props.$headerseparatorcolor;
}, function (props) {
  return props.$bodycolor;
});
export default StyledPanelForm;